import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Flex } from "@UI/Components/Flex/Flex";
import { Icon } from "@UI/Components/Icon/Icon";
import { Text } from "@UI/Components/Text/Text";
import { Star } from "@UI/Components/Icons/Star";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { formatRating } from "@modules/ServiceProviders/utils/formatRating";
import { MetricCard } from "../MetricCard";
import messages from "../messages";

interface IStarTalentCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const StarTalentCard = memo(({ metric, onClick }: IStarTalentCard) => {
  const avgRating =
    metric?.value !== null && metric?.value !== undefined
      ? Number(metric.value)
      : null;
  const threshold = Number(metric?.threshold ?? 4.8);
  const reached =
    metric !== undefined && avgRating !== null && avgRating >= threshold;
  const evaluationsCount =
    metric?.computationDetails?.evaluationsCount ?? 0;

  return (
    <MetricCard
      title={<FormattedMessage {...messages.starTalentTitle} />}
      onClick={onClick}
      description={
        <FormattedMessage {...messages.minRating} values={{ value: threshold }} />
      }
      state={reached ? "reached" : "not-reached"}
    >
      <Flex align="center" gap={2}>
        <Icon as={Star} color="orange.500" boxSize={6} />
        <Text fontWeight="700" fontSize="2xl" color="gray.800">
          {avgRating !== null ? formatRating(avgRating) : "—"}
        </Text>
        <Text fontSize="sm" color="gray.700">
          <FormattedMessage
            {...messages.reviews}
            values={{ count: evaluationsCount }}
          />
        </Text>
      </Flex>
    </MetricCard>
  );
});

StarTalentCard.displayName = "StarTalentCard";
